<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-row style="margin-bottom:12px">
                <el-button size="small" v-on:click="add()" type="primary">新增模板</el-button>
                <el-button size="small" v-on:click="search()" type="primary">刷新</el-button>
            </el-row>
           <!--  <el-form ref="queryParams" inline label-position="right" label-width="80px" v-model="queryParams">
                <el-form-item label="名称">
                    <el-input size="small" v-model="queryParams.warehouseName" placeholder="" style="width: 120px" />
                </el-form-item>
                <el-form-item label="地区">
                    <el-input size="small" v-model="queryParams.country" placeholder="地区" style="width: 120px" />
                </el-form-item>
                <el-form-item>
                    <el-button size="small" v-on:click="search()" type="primary">搜索</el-button>
                    <el-button size="small" v-on:click="reset()">重置</el-button>
                </FormItem -->
            </el-form>
            <Table :loading="loading" :columns="columns" :data="freightTpls" border>
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
        </Content>
        <CFreightTpl ref="tplDialog" :freightTplId="freightTpl.id" @ok="getList()" />
    </div>
</template>
<script>
    import CFreightTpl from "./CFreightTpl"
export default {
    name: 'FreightTpl',
    data() {
        return {
            loading: false,

            queryParams: {

            },
            others: {

            },
            freightTpl: {

            },
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            freightTpls: [

            ],
            rules: {},
            columns: [ {
                    title: '名称',
                    key: 'name',
                    width: 130,
                    align: 'center'
                },{
                    title: '别名备注',
                    key: 'remark',
                    width: 130,
                    align: 'center'
                },{
                    title: '仓库',
                    key: 'warehouseName',
                    width: 130,
                    align: 'center'
                }, {
                    title: '地区',
                    key: 'country',
                    width: 130,
                    align: 'center'
                }, {
                    title: '集运类型',
                    key: 'country',
                    width: 130,
                    align: 'center',
                    render:(h,params)=>{
                        var btns=[];
                        let row=params.row;
                       
                        btns.push(h("div",{},row.airFreight=="1"?"空运":"海运"));
                        
                        return h("div",{},btns);
                    }
                },{
                    title: '计算方式',
                    key: 'isVolume',
                    width: 130,
                    align: 'center',
                    render:(h,params)=>{
                        var btns=[];
                        var txt="";
                        if(params.row.isVolume==1)
                        {
                            txt=",按体积重("+params.row.volume+")";
                        }
                        else{
                            txt=",按实重";
                        }
                        if(params.row.type==1)
                        {
                            btns.push(h("div",{},"重量"+txt));
                        }
                        else{
                            btns.push(h("div",{},"体积"));
                        }
                        return h("div",{},btns);
                    }
                }, {
                    title: '费用规则',
                    key: 'firstWeight',
                    width: 180,
                    align: 'center',
                    render:(h,params)=>{
                        var btns=[];
                        let row=params.row;
                        let unit=row.type==1?"KG":"m3";
                        btns.push(h("div",{},"起步："+row.firstWeight+unit+","+row.firstMoney+"￥"));
                        btns.push(h("div",{},"续重："+row.secondWeight+unit+","+row.secondMoney+"￥"));
                       
                        return h("div",{style:{margin:"10px 0px"}},btns);
                    }
                },  {
                    title: '产品类型',
                    key: 'productType',
                    width: 130,
                    align: 'center',
                    render:(h,params)=>{
                        var btns=[];
                        let row=params.row;
                       
                        btns.push(h("div",{},row.productType=="P"?"普货":row.productType=="TA"?"特货A":"特货B"));
                        
                        return h("div",{},btns);
                    }
                }, {
                    title: '操作',
                    key: 'state',

                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        return h("div", [
                            h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "error" }, on: { click: () => { this.delete(row.id); } } }, "删除"),
                            h("Button", { style: { marginRight: "5px" }, props: { size: "small" }, on: { click: () => { this.edit(row); } } }, "修改")

                        ]);
                    }
                }

            ]
        };
    },
    components:{
        CFreightTpl
    },
    mounted: function() {
        this.getList();

    },
    methods: {
        
        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {
            this.queryParams = {};
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/freighttpl/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.freightTpls = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        delete: function(id) {
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否执行该操作",
                onOk: function() {
                    me.$http.post("/ware/freighttpl/doDelete.action", { id: id }).then(response => {
                        var body = response;
                        if (body.status == 0) {
                            me.getList();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {

                    });
                },
                onCancel: function() {

                }
            });
        },
        edit: function(row) {
            this.freightTpl = row;
            this.$refs['tplDialog'].showDialog();
        },
        add: function() {
            this.freightTpl={};
            this.$refs['tplDialog'].showDialog();
        }

    }
}
</script>
<style scoped>
</style>